import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ColorMenuComponent } from './color-menu.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		MatMenuModule
	],
	exports: [
		ColorMenuComponent
	],
	declarations: [
		ColorMenuComponent
	]
})
export class ColorMenuModule {}
